import React from "react";
import { FIELD_BG } from "./lib/data";
import { Hero } from "./components/Hero";
import { MailReviewCarousel } from "./components/MailReviewCarousel";
import { ProblemSection } from "./components/ProblemSection";
import { ModulesSection } from "./components/ModulesSection";
import { StarReviews } from "./components/StarReviews";
import { BonusSection } from "./components/BonusSection";
import { ComparisonTable } from "./components/ComparisonTable";
import { FinalOffer } from "./components/FinalOffer";
import { Testimonials } from "./components/Testimonials";
import { Objections } from "./components/Objections";
import { Support } from "./components/Support";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="relative min-h-full w-full bg-[#0a1f34]" data-id="element-0" data-mp="2wi5l9cv6edmo">
      {/* Blurred futsal court background */}
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: `url(${FIELD_BG})`,
      filter: "blur(8px)",
      transform: "scale(1.08)"
    }} data-id="element-1" data-mp="23vchsmqej08z" />
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-[#0a1f34]/80" data-id="element-2" data-mp="3mk8710lxsfel" />

      <main className="relative z-10 mx-auto w-full max-w-md" data-id="element-3" data-mp="3rbzmog3k10py">
        <Hero data-id="element-4" data-mp="3relw6la09qat" />
        <MailReviewCarousel data-id="element-5" data-mp="5ott78p769p" />
        <ProblemSection data-id="element-6" data-mp="4wxfu7a14id" />
        <ModulesSection data-id="element-7" data-mp="56ntiw8hdol" />
        <StarReviews data-id="element-8" data-mp="7sxbo2oq39g" />
        <BonusSection data-id="element-9" data-mp="2zlle8zeb8glo" />
        <ComparisonTable data-id="element-10" data-mp="2zm4xqkjlzd1t" />
        <FinalOffer data-id="element-11" data-mp="2zmwggus3xgao" />
        <Testimonials data-id="element-12" data-mp="2znfyebhrc4op" />
        <Objections data-id="element-13" data-mp="33m5a7zn5de68" />
        <Support data-id="element-14" data-mp="33nq5jrhad155" />
      </main>

      <PurchasePopup data-id="element-15" data-mp="33myjb79kwfrj" />
    </div>;
}